var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('file-explorer',{key:_vm.title,attrs:{"title":_vm.title,"key_name":_vm.key_name,"key_value":_vm.key_value,"readOnly":_vm.readOnly}}),_vm._l((_vm.fileModals),function(comp){return _c(comp.name,{key:comp.id,tag:"component"})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }